import * as React from "react";
import { Button, Text } from "@uikit";
import { SearchCircleIcon, SearchIcon } from "@heroicons/react/outline";

import { useStaticQuery, graphql, Link } from "gatsby";
import { Attraction, AttractionExtended } from "@kalabo/golfsavers-common";
import { Coordinate } from "@kalabo/golfsavers-common";
import { calcCrow } from "@kalabo/golfsavers-common";

interface iAttractionsProps {
  center: Coordinate;
  maxDistance?: number;
}

const NearbyAttractions = ({ center, maxDistance = 10 }: iAttractionsProps) => {
  const data = useStaticQuery(graphql`
    query {
      attractions: allGolfsaversAttractions {
        edges {
          node {
            id
            latitude
            link
            longitude
            name {
              en
            }
            region_id
            type
          }
        }
      }
    }
  `);

  const attractions = data.attractions.edges
    .map((edge: any) => edge.node as AttractionExtended)
    .map((attraction: AttractionExtended) => {
      return {
        ...attraction,
        distance: calcCrow(
          center.latitude,
          center.longitude,
          attraction.latitude,
          attraction.longitude
        ),
      };
    })
    .sort((a: AttractionExtended, b: AttractionExtended) => {
      return a.distance.km - b.distance.km;
    })
    .filter((attraction: AttractionExtended) => {
      return attraction.distance.km < maxDistance;
    })
    .slice(0, 5);

  if (attractions.length === 0) return null;

  return (
    <div className="mb-9">
      <Text
        size={17}
        weight="semibold"
        color="black90"
        element="h3"
        leading={1.3}
        className="mb-4"
      >
        Nearby Attractions
      </Text>
      <div className="flex flex-col gap-2">
        {attractions.map((attraction: AttractionExtended, idx: any) => {
          return (
            <div key={idx} className="flex justify-between">
              <Text size={15} color="black90" leading={1.3}>
                {" "}
                {attraction.name.en}
              </Text>
              <Text
                size={15}
                color="black90"
                leading={1.3}
                className="whitespace-nowrap"
              >
                {attraction.distance.km.toFixed(1)} km
              </Text>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NearbyAttractions;
